import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root'
})

export class SessionStorageService {

    constructor() { }

    public saveData(key: string, value: any) {
        sessionStorage.setItem(key, JSON.stringify(value));
    }

    public getData<T>(key: string): T {
        return JSON.parse(sessionStorage.getItem(key)) as T;
    }

    public removeData(key: string) {
        sessionStorage.removeItem(key);
    }

    public clearData() {
        sessionStorage.clear();
    }
}
